import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

// 404 for unknown paths (incl. legacy /products/*.htm from the previous site).
// Sets robots noindex so Google drops these URLs; keeps a helpful, on-brand page.
export default function NotFound() {
  const { lang } = useLang();
  const it = lang === "it";

  useEffect(() => {
    const prevTitle = document.title;
    document.title = it ? "Pagina non trovata · Your Black Limo" : "Page not found · Your Black Limo";
    let meta = document.head.querySelector('meta[name="robots"]');
    const created = !meta;
    const prevContent = meta ? meta.getAttribute("content") : null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, follow");
    return () => {
      document.title = prevTitle;
      if (created) meta.remove();
      else if (prevContent !== null) meta.setAttribute("content", prevContent);
    };
  }, [it]);

  return (
    <section data-testid="not-found" className="min-h-[70vh] flex items-center px-6 md:px-12 bg-[#0A0A0A]">
      <div className="max-w-2xl mx-auto text-center py-24">
        <p className="text-[#C5A059] text-sm tracking-[0.3em] uppercase mb-6">404</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-white mb-6">
          {it ? "Pagina non trovata" : "Page not found"}
        </h1>
        <p className="text-white/60 text-base leading-relaxed mb-10">
          {it
            ? "La pagina che cerchi non esiste o è stata spostata. Torna alla home o scopri i nostri servizi di trasporto privato con autista in Toscana."
            : "The page you're looking for doesn't exist or has moved. Head back home or explore our private chauffeur services across Tuscany."}
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="px-8 py-3 bg-[#C5A059] text-black text-sm tracking-wide hover:bg-[#d4b46e] transition-colors"
          >
            {it ? "Torna alla home" : "Back to home"}
          </Link>
          <Link
            to="/services"
            data-testid="notfound-services-link"
            className="px-8 py-3 border border-white/20 text-white text-sm tracking-wide hover:border-[#C5A059] transition-colors"
          >
            {it ? "I nostri servizi" : "Our services"}
          </Link>
          <Link
            to="/cruise-tours"
            data-testid="notfound-journeys-link"
            className="px-8 py-3 border border-white/20 text-white text-sm tracking-wide hover:border-[#C5A059] transition-colors"
          >
            {it ? "Itinerari in Toscana" : "Tuscany journeys"}
          </Link>
        </div>
      </div>
    </section>
  );
}
